import React from 'react';

import {
  Switch,
  Route,
  useRouteMatch,
  Redirect,
} from 'react-router-dom';

import useAuth from '@/hooks/useAuth';
import GuardedRoute from '@/containers/GuardedRoute';
import OAuthLogin from './components/OAuthLogin';
import OAuthCallback from './components/OAuthCallback';
import OAuthConnectPhoneNumber from './components/OAuthConnectPhoneNumber';
import Logout from './components/Logout';

const AuthPage = () => {
  const { path } = useRouteMatch();
  const [checkAuthenticated] = useAuth();

  return (
    <Switch>
      <Route exact path={path}>
        <Redirect to={`${path}/line/login`} />
      </Route>
      <Route path={`${path}/:provider/login`}>
        <OAuthLogin />
      </Route>
      <Route path={`${path}/:provider/callback`}>
        <OAuthCallback />
      </Route>
      <GuardedRoute
        path={`${path}/:provider/connect-phone-number`}
        checkAuthenticated={checkAuthenticated}
        component={OAuthConnectPhoneNumber}
        redirectPath="/register"
      />
      <Route path={`${path}/logout`}>
        <Logout />
      </Route>
    </Switch>
  );
};

export default AuthPage;
